const configs = {
  sentryDSN: 'https://094808773c0445f4b00ece0b7c93ed92@o1175642.ingest.sentry.io/6342026',
}
export default configs
